import { createContext, useContext, useState } from 'react';

export type ProxyRole = 'admin' | 'owner' | 'dispatcher' | 'office' | 'driver';

export const ROLE_LABELS: Record<ProxyRole, string> = {
  admin:      'Admin',
  owner:      'Owner',
  dispatcher: 'Dispatcher',
  office:     'Office',
  driver:     'Driver',
};

export const ROLE_COLORS: Record<ProxyRole, string> = {
  admin:      '#E05252',
  owner:      '#4F8EF7',
  dispatcher: '#F7834F',
  office:     '#3DBE7A',
  driver:     '#9B6CF7',
};

interface ProxyRoleContextValue {
  proxyRole: ProxyRole | null;
  setProxyRole: (role: ProxyRole | null) => void;
}

const ProxyRoleContext = createContext<ProxyRoleContextValue>({
  proxyRole: null,
  setProxyRole: () => {},
});

const STORAGE_KEY = 'twm_proxy_role';

export function ProxyRoleProvider({ children }: { children: React.ReactNode }) {
  const [proxyRole, setProxyRoleState] = useState<ProxyRole | null>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return (stored as ProxyRole) ?? null;
  });

  const setProxyRole = (role: ProxyRole | null) => {
    if (role === null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, role);
    }
    setProxyRoleState(role);
  };

  return (
    <ProxyRoleContext.Provider value={{ proxyRole, setProxyRole }}>
      {children}
    </ProxyRoleContext.Provider>
  );
}

export function useProxyRole() {
  return useContext(ProxyRoleContext);
}
